import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { 
  FiMonitor, FiCoffee, FiShoppingBag, FiTruck, 
  FiPhoneCall, FiSun, FiHome, FiTool, FiArrowRight
} from 'react-icons/fi';

const categories = [
  { id: 'buero', title: 'Büro & Home Office', icon: FiMonitor, color: 'bg-blue-50 text-blue-600' },
  { id: 'gastro', title: 'Gastronomie & Event', icon: FiCoffee, color: 'bg-orange-50 text-orange-600' },
  { id: 'verkauf', title: 'Verkauf & Handel', icon: FiShoppingBag, color: 'bg-pink-50 text-pink-600' },
  { id: 'logistik', title: 'Lager & Logistik', icon: FiTruck, color: 'bg-slate-100 text-slate-700' },
  { id: 'callcenter', title: 'Callcenter', icon: FiPhoneCall, color: 'bg-emerald-50 text-emerald-600' },
  { id: 'reinigung', title: 'Reinigung', icon: FiSun, color: 'bg-amber-50 text-amber-600' },
  { id: 'aushilfe', title: 'Allg. Aushilfe', icon: FiHome, color: 'bg-purple-50 text-purple-600' },
  { id: 'handwerk', title: 'Handwerk & Bau', icon: FiTool, color: 'bg-red-50 text-red-600' },
];

const JobCategories = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-end gap-6 mb-16">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-extrabold mb-4">Jobbereiche entdecken</h2>
            <p className="text-lg text-slate-500">
              Wähle deinen Bereich und finde heraus, welche Jobs wir aktuell vermitteln.
            </p>
          </div>
          <Link to="/jobbereiche" className="btn-outline group">
            Alle Bereiche
            <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {categories.map((cat, index) => (
            <motion.div
              key={cat.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
            >
              <Link 
                to="/jobbereiche" 
                className="group block p-8 bg-slate-50 rounded-[32px] hover:bg-white hover:shadow-2xl hover:shadow-slate-200/60 transition-all duration-500 border border-transparent hover:border-slate-100"
              >
                <div className={`w-14 h-14 ${cat.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                  <SafeIcon icon={cat.icon} className="text-2xl" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-teal-600 transition-colors">{cat.title}</h3>
                <div className="mt-4 flex items-center text-sm font-bold text-slate-400 group-hover:text-teal-600 transition-colors">
                  Jobs ansehen
                  <SafeIcon icon={FiArrowRight} className="ml-2 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobCategories;